import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from "@angular/forms";
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import _ from 'lodash';
import { debounceTime } from 'rxjs/operators';
import { FormDialogComponent } from '../form-dialog/form-dialog.component';
import { AutoCompleteValidators } from 'src/app/shared/validators/auto-complete-validators';
import { IChildProject } from 'src/app/models/projects/project.model';
import { Query, ResolverService } from 'src/app/services/api/resolver.service';
import { SelectDialog, SelectDialogOptions } from '../select-dialog/select-dialog.component';



export interface ServiceSelectDialogOptions extends SelectDialogOptions {
    query: Query;
    service: ResolverService<any>,
}

@Component({
    selector: 'app-service-select-dialog',
    templateUrl: './service-select-dialog.component.html',
    styleUrls: ['./service-select-dialog.component.scss'],
})
export class ServiceSelectDialog extends SelectDialog implements OnInit {

    query: Query;
    service: ResolverService<any>;

    loading: boolean = false;

    constructor(protected fb: FormBuilder,
        protected dialogRef: MatDialogRef<FormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public config: ServiceSelectDialogOptions) {
        super(fb, dialogRef, config);

        // INIT FROM OPTIONS
        this.query = config.query || {};
        this.service = config.service;
    }


    async ngOnInit(): Promise<void> {
        await super.ngOnInit();
        //Retriving
        this._data = await this.retrieve();
        this.controls['data'].addValidators(AutoCompleteValidators.mustBeInList(this.data, '_id', true));
        this.subscription.add(this.form.controls['data'].valueChanges.pipe(debounceTime(600)).subscribe(async (value: string) => {
            if (value && _.isString(value)) {
                this._data = await this.retrieve(value);
            }
        }));
    }

    async retrieve(search?: string) {
        this.loading = true;
        const query = search && !_.isEmpty(search.trim()) ? { __search: search.trim(), ...this.query } : this.query;
        const entities = await this.service.find(query, { $triggerEntityList: false });
        this.loading = false;
        return entities ? entities.map(this.map.bind(this)).filter((v: IChildProject) => { return this.predicate(v); }) : [];
    }
}